import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/playground')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      <div className="w-full overflow-x-auto">
        <table className="w-full table-fixed border-collapse">
          <thead>
            <tr>
              <th className="w-[80px] border px-2">ID</th>
              <th className="border px-2">Name</th>
              <th className="w-[150px] border px-2">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-2">1</td>
              <td className="border px-2">John Doe</td>
              <td className="border px-2">Edit</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
